export default {
    TASK_STATISTICS_TITLE: "Статистика задач"
};
